module.exports = __webpack_public_path__ + "img/alien-stare.6adfaa5e.svg";